import { render, staticRenderFns } from "./DriversRemarksList.vue?vue&type=template&id=037db3cf&scoped=true&"
import script from "./DriversRemarksList.vue?vue&type=script&lang=js&"
export * from "./DriversRemarksList.vue?vue&type=script&lang=js&"
import style0 from "./DriversRemarksList.vue?vue&type=style&index=0&id=037db3cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037db3cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDataTable})
